import { render, staticRenderFns } from "./familia.vue?vue&type=template&id=5d23f516&lang=html"
import script from "./familia.vue?vue&type=script&lang=js"
export * from "./familia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports